import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider } from 'material-hu';
import { SnackbarProvider } from 'notistack';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from 'src/App';
import { AuthProvider } from 'src/contexts/JWTContext';
import { EventUserProvider } from 'src/contexts/EventUser';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import { LastPostViewedProvider } from 'src/contexts/LastPostViewed';
import reportWebVitals from 'src/reportWebVitals';
import * as serviceWorker from 'src/serviceWorker';
import { ReactQueryClientProvider } from 'src/config/react-query';
import 'src/config/sentry';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <SettingsProvider>
          <SnackbarProvider
            dense
            maxSnack={3}
            variant="success"
          >
            <ReactQueryClientProvider>
              <BrowserRouter>
                <AuthProvider>
                  <EventUserProvider>
                    <LastPostViewedProvider>
                      <App />
                    </LastPostViewedProvider>
                  </EventUserProvider>
                </AuthProvider>
              </BrowserRouter>
              <ReactQueryDevtools initialIsOpen={false} />
            </ReactQueryClientProvider>
          </SnackbarProvider>
        </SettingsProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  </StrictMode>,
);

serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
